<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">My Account</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link>
      /

      <b>My Account</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card mb-4">
          <div class="card-body">
            <!-- Profile -->
            <div class="form-group mb-3">
              <label for="full-name">Name</label>
              <input
                class="form-control"
                type="text"
                v-model="user[0].user.name"
              />
            </div>

            <div class="form-group mb-3" v-if="user[0].position != 'Vendor'">
              <label for="Position">Position</label>
              <input
                class="form-control"
                type="text"
                v-model="user[0].position"
              />
            </div>

            <div v-if="user[0].position != 'Vendor'">
              <div
                class="form-group mb-3"
                v-for="(role, index) in user[0].user.roles"
                v-bind:key="index"
              >
                <label for="Position">Role {{ index + 1 }}</label>
                <input
                  class="form-control"
                  type="text"
                  :value="role.name"
                  disabled
                />
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="email">Email</label>
              <input
                class="form-control"
                type="email"
                v-model="user[0].user.email"
              />
            </div>
            <div class="form-group mb-3">
              <label for="email">Username</label>
              <input
                class="form-control"
                type="email"
                v-model="user[0].user.username"
              />
            </div>

            <!-- Button -->
            <div class="text-center">
              <button
                @click="update_account()"
                class="btn btn-rounded btn-primary"
                style="width: 100px"
              >
                Update
              </button>
            </div>

            <hr />

            <!-- Change Password -->
            <div class="form-group mb-3">
              <label for="old-password">Current Password</label>
              <input
                class="form-control"
                type="password"
                v-model="current_password"
                required
              />
            </div>

            <div class="form-group mb-3">
              <label for="password">New Password</label>
              <input class="form-control" type="password" v-model="password" />
            </div>

            <div class="form-group mb-3">
              <label for="password-confirm">Confirm New Password</label>
              <input
                class="form-control"
                type="password"
                v-model="password_confirmation"
              />
            </div>

            <!-- Button -->
            <div class="text-center">
              <button
                @click="update_password()"
                class="btn btn-rounded btn-primary"
                style="width: 150px"
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "account",
  components: {},

  data() {
    return {
      user: {
        position: "",
        user: {
          name: "",
          roles: [],
          email: "",
        },
      },
      current_password: "",
      password: "",
      password_confirmation: "",
      update: [],
    };
  },

  methods: {
    loadUser() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/staffs", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.user = res.data;
          });
      }
    },

    update_account() {
      let token = localStorage.getItem("token");

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                "/staffs/update",
                {
                  name: this.user[0].user.name,
                  email: this.user[0].user.email,
                  username: this.user[0].user.username,
                  position: this.user[0].position,
                  _method: "PATCH",
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                this.update = res.data.message;
                swal({
                  icon: res.data.success ? "success" : "error",
                  text: res.data.message,
                });
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },

    update_password() {
      let token = localStorage.getItem("token");

      //check if has token
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"],
        }).then((confirm) => {
          if (confirm) {
            axios
              .post(
                "/staffs/update_password",
                {
                  current_password: this.current_password,
                  password: this.password,
                  password_confirmation: this.password_confirmation,
                  _method: "PATCH",
                },
                {
                  headers: {
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .then((res) => {
                if (res.data.success) {
                  swal({
                    icon: "success",
                    text: "Successful!",
                  }).then(() => {
                    localStorage.clear();
                    this.$router.push("/login");
                  });
                } else {
                  swal({
                    icon: "error",
                    text: res.data.message,
                  }).then(() => {
                    this.current_password = "";
                    this.password = "";
                    this.password_confirmation = "";
                  });
                }
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled",
            });
          }
        });
      }
    },
  },

  mounted() {
    this.loadUser();
  },
};
</script>
